// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ti0c","question":"styles_question__32PFX","description":"styles_description__VHFvs"};